var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileAvatarReferral = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_558_44408)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#0E1010"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.271429,
    y: 0.271429,
    width: 37.4571,
    height: 37.4571,
    rx: 18.7286,
    stroke: "#323232",
    strokeWidth: 0.542857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2005 3.08984C15.4049 3.08984 12.6937 5.25877 12.6937 5.25877L13.2359 6.34323C11.6092 6.88546 10.5248 7.96992 10.5248 7.96992L11.067 9.59661C9.98255 10.6811 9.44032 12.3078 9.44032 12.3078L10.5248 13.3922C10.5248 13.3922 9.44032 14.4767 9.44032 16.6456L12.305 18.5551C12.8398 19.9363 13.7416 21.2713 14.7853 22.3486L14.6063 24.9506L5.49385 27.1281C5.20153 27.1979 5.08611 27.5514 5.28459 27.7771C8.6466 31.5999 12.9457 34.911 18.7977 34.911C25.2855 34.911 29.3914 31.7687 32.7408 27.7688C32.93 27.543 32.8151 27.199 32.5292 27.1277L23.7946 24.9506L23.6156 22.3486C24.6594 21.2713 25.5607 19.9363 26.0959 18.5551L28.9606 16.6456C28.9606 14.4767 27.8762 13.3922 27.8762 13.3922L28.9606 12.3078C28.9606 12.3078 28.4184 10.6811 27.3339 9.59661L27.8762 7.96992C27.8762 7.96992 26.7917 6.88546 25.165 6.34323L25.7072 5.25877C25.7072 5.25877 22.9961 3.08984 19.2005 3.08984ZM20.2849 9.05438L21.3694 11.7655L23.9122 10.4936C23.963 10.5525 24.0805 10.6811 24.0805 10.6811L24.6228 14.4767C24.9546 14.4767 25.3371 14.7349 25.5473 15.0708C25.6292 15.2599 25.7072 15.5164 25.7072 15.8323C25.7072 16.7427 24.9474 17.3509 24.9447 17.3531L24.7488 17.5013L24.6673 17.7343C23.5915 20.8261 20.6092 23.1524 19.2005 23.1524C17.7918 23.1524 14.8095 20.8261 13.7337 17.7343L13.6521 17.5013L13.4562 17.3531C13.4486 17.3471 12.6937 16.7492 12.6937 15.8323C12.6937 15.5171 12.7707 15.261 12.8515 15.0729C13.0613 14.7358 13.4455 14.4767 13.7782 14.4767L14.3204 10.6811C14.3204 10.6811 14.9751 9.88317 15.9958 9.15181L17.0315 11.2233L20.2849 9.05438ZM16.3252 23.6734C17.3088 24.3626 18.3183 24.7791 19.2005 24.7791C20.0827 24.7791 21.0927 24.3626 22.0768 23.6734L22.3734 27.9774C21.6988 28.2658 20.6497 28.5747 19.2005 28.5747C17.7513 28.5747 16.7021 28.2658 16.0276 27.9774L16.3252 23.6734Z",
    fill: "#2D5EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_558_44408",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.48786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0 0.54902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_558_44408"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileAvatarReferral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-avatar-referral.df08b07d316df7f13db4c4513956c432.svg";